// extracted by css-extract-rspack-plugin
export default {"cls1":"AiSummary-cls1_wX4","cls2":"AiSummary-cls2_Hby AiSummary-cls1_wX4","type-finding":"AiSummary-type-finding_xYk","type-figure":"AiSummary-type-figure_QAh"};